import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconName } from '@fortawesome/free-solid-svg-icons';
import { TypeSectionGiftFields } from '../../../models/contentful-content-types/section-gift';
import { AssetFile } from 'contentful';
import { ButtonComponent } from '../button/button.component';
import { ScrollSectionDirective } from '../../utils/directives/scroll-section.directive';

@Component({
  imports: [CommonModule, FontAwesomeModule, ButtonComponent, ScrollSectionDirective],
    selector: 'jnguyen-section-gift',
    templateUrl: './section-gift.component.html',
    styleUrls: ['./section-gift.component.scss'],
})
export class SectionGiftComponent {
  @Input() data: TypeSectionGiftFields;
  documentToHtmlString = documentToHtmlString;

  getIcon(icon: IconName, iconClass: string): string[] {
    return [iconClass, icon];
  }

   getImageUrl(url: string | AssetFile) {
    if (typeof url === "string") {
      const cutUrl = url.replace(/\/\/images\.ctfassets\.net\//, "");
      return `${cutUrl}`;
    }
  }
}
